import {
  DataConnectionError,
  DataConnectionIndexParams,
  DataConnectionResultItem,
  provideDataClass
} from "scrivito"

import { getPisaClient } from "../pisaClient"

function transformEqualFiltersToQueryParams(params: DataConnectionIndexParams) {
  const filters = params.filters()
  return Object.fromEntries(
    Object.entries(filters)
      .filter(([, value]) => value.operator === "equals")
      .map(([key, value]) => [key, value.value])
  ) as Record<string, string>
}
function transformSearchStringToQueryParams(params: DataConnectionIndexParams) {
  const pairs = params
    .search()
    .split("&")
    .map(s => s.split("="))
  return Object.fromEntries(pairs) as Record<string, string>
}

// export const Opportunity = provideDataClass(
//   "Opportunity",
//   (async () => {
//     const restApi = await pisaConfig("opportunity")
//     return { restApi }
//   })()
// )

const clientPromise = getPisaClient("opportunity")

export const Opportunity = provideDataClass("Opportunity", {
  attributes: {},
  connection: {
    index: async params => {
      const client = await clientPromise
      if (!client) {
        return new DataConnectionError("Pisa Client not found")
      }

      return client.get("", {
        params: {
          ...transformEqualFiltersToQueryParams(params),
          ...transformSearchStringToQueryParams(params)
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      }) as any
    },
    get: async () => {
      return new DataConnectionError(
        "Fetching Opportunity by Pisa ID is not supported"
      )
    },
    create: async attributes => {
      const client = await clientPromise
      if (!client) {
        throw new DataConnectionError("Pisa Client not found")
      }

      // Scrivito for some reason removes dashes from attributes.
      return client.post("", {
        data: {
          ...attributes,
          external_id: attributes.external_id
        }
      }) as unknown as DataConnectionResultItem
    }
  }
})
